import { Component } from '@angular/core';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  visible = true;
}
